import { jsx as _jsx } from "react/jsx-runtime";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { twMerge } from 'tailwind-merge';
import { extractProps } from '@radix-ui/themes/helpers';
import _omit from 'lodash.omit';
import { forwardRef } from 'react';
import { AccessibleIcon } from '../accessible-icon/index.js';
import { withMappingProps } from '../../utils/radix.js';
import { iconPropDefs } from './icon.props.js';
const ScaleUIRadixIcon = forwardRef((props, forwardedRef) => {
    const { className, label, color, ...otherProps } = extractProps(props, _omit(iconPropDefs, 'icon'));
    return (_jsx(AccessibleIcon, { label: label, children: _jsx(FontAwesomeIcon, { className: twMerge('rt-Icon', className), "data-accent-color": color, ref: forwardedRef, ...otherProps }) }));
});
ScaleUIRadixIcon.displayName = 'Icon';
export const Icon = withMappingProps(ScaleUIRadixIcon);
//# sourceMappingURL=icon.js.map